import { put, select } from 'redux-saga/effects';
import { preloaderActionTypes } from './preloader.actions';

import { preloadResource } from 'utils/preloader';

export function* preloadVideo(action) {
    try {
        const state = yield select((state) => state.preloader);

        if (state.currentlyLoading) {
            const resource = {
                resourceType: 'video',
                resourceId: action.payload.videoId,
                resourceUrl: action.payload.videoUrl,
            };

            yield put({
                type: preloaderActionTypes.PRELOAD_VIDEO_IN_QUEUE,
                payload: { resource },
            });
        } else {
            yield put({
                type: preloaderActionTypes.PRELOAD_VIDEO_FETCHING,
                payload: { videoId: action.payload.videoId, videoUrl: action.payload.videoUrl },
            });
        }
    } catch (error) {
        yield put({
            type: preloaderActionTypes.PRELOAD_VIDEO_FAILURE,
            payload: { videoId: action.payload.videoId, error },
        });
    }
}

export function* fetchingVideo(action) {
    try {
        const response = yield preloadResource(action.payload.videoUrl);

        // Use the blob URL on every platform — preloadResource re-wraps
        // the bytes with an explicit video/mp4 MIME type which iOS 18.7+
        // requires. The original streaming URL is kept as a fallback so
        // VideoComponent can swap on src-load failure (older Safari can
        // still reject blob URLs, and we'd rather degrade to streaming
        // than show the user a black screen with MEDIA_ERR_SRC_NOT_SUPPORTED).
        const videoUrl = URL.createObjectURL(response);
        const fallbackUrl = action.payload.videoUrl;
        yield put({
            type: preloaderActionTypes.PRELOAD_VIDEO_DONE,
            payload: { videoId: action.payload.videoId, videoUrl, fallbackUrl },
        });
    } catch (error) {
        yield put({
            type: preloaderActionTypes.PRELOAD_VIDEO_FAILURE,
            payload: { videoId: action.payload.videoId, error },
        });
    }

    // Drain the queue regardless of whether THIS preload succeeded or failed
    // — otherwise a single failed video would leave any queued videos stuck
    // at loading:true forever.
    const state = yield select((state) => state.preloader);
    if (state.queue.length > 0) {
        const nextVideoToPreload = state.queue[0];
        yield put({
            type: preloaderActionTypes.PRELOAD_VIDEO,
            payload: {
                videoId: nextVideoToPreload.resourceId,
                videoUrl: nextVideoToPreload.resourceUrl,
                loadedFromQueue: true,
            },
        });
    }
}
